import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _defineProperty from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useState, useMemo, useEffect, useContext, createContext } from 'react';
import isEqual from "lodash/isEqual";
import { AuthService } from '@okta/okta-react';
import { fetchUserInfo } from './fetchUserInfo';
export var AuthStateContext = createContext(undefined);
export var useAuthState = function useAuthState() {
  return useContext(AuthStateContext);
};

function convertAuthState(state) {
  var isAuthenticated = state.isAuthenticated,
      isPending = state.isPending,
      accessToken = state.accessToken,
      idToken = state.idToken,
      error = state.error;
  var newState = {
    isAuthenticated: !!isAuthenticated,
    isPending: !!isPending,
    accessToken: accessToken,
    idToken: idToken,
    userInfo: null
  };

  if (error) {
    newState.error = error;
  }

  return newState;
}

export var AuthStateProvider = function AuthStateProvider(_ref) {
  var children = _ref.children,
      authServiceProp = _ref.authService,
      props = _objectWithoutProperties(_ref, ["children", "authService"]);

  var authService = useMemo(function () {
    return authServiceProp || new AuthService(props);
  }, [authServiceProp]);

  var _useState = useState(function () {
    return convertAuthState(authService.getAuthState());
  }),
      _useState2 = _slicedToArray(_useState, 2),
      authState = _useState2[0],
      setAuthState = _useState2[1];

  useEffect(function () {
    var hasEffectChange = false;
    var unsubscribe = authService.on('authStateChange', function () {
      var newState = convertAuthState(authService.getAuthState());
      var isAuthenticated = newState.isAuthenticated,
          accessToken = newState.accessToken;

      if (!isAuthenticated || !accessToken) {
        setAuthState(function (oldState) {
          if (isEqual(oldState, newState)) {
            return oldState;
          }

          return newState;
        });
        return;
      }

      var loadAuthData = function loadAuthData() {
        var idToken, userInfo;
        return _regeneratorRuntime.async(function loadAuthData$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _regeneratorRuntime.awrap(authService._oktaAuth.tokenManager.get('idToken'));

              case 2:
                idToken = _context.sent;

                if (!idToken) {
                  _context.next = 7;
                  break;
                }

                _context.t0 = idToken.claims;
                _context.next = 10;
                break;

              case 7:
                _context.next = 9;
                return _regeneratorRuntime.awrap(fetchUserInfo(accessToken));

              case 9:
                _context.t0 = _context.sent;

              case 10:
                userInfo = _context.t0;

                if (!hasEffectChange) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return");

              case 13:
                setAuthState(_objectSpread({}, newState, {
                  userInfo: userInfo
                }));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, null, null, null, Promise);
      };

      loadAuthData();
    });
    authService.updateAuthState();
    return function () {
      hasEffectChange = true;
      unsubscribe();
    };
  }, [authService]);
  return React.createElement(AuthStateContext.Provider, {
    value: {
      authService: authService,
      authState: authState
    }
  }, children);
};
AuthStateProvider.__docgenInfo = {
  componentName: "AuthStateProvider",
  packageName: "@jutro/auth",
  description: "Initiate Okta's AuthService and store auth state\nSimilar to okta-react's Secure component",
  displayName: "AuthStateProvider",
  methods: [],
  actualName: "AuthStateProvider"
};